<template>
  <div class="viewer-help-tab w-100">
    <div class="ap-title ap-title__main px-3 pt-3 pb-2">
      <span>{{ $t('global.viewer') }}</span>
    </div>
    <div class="px-3">
      <shortcuts-and-voice-commands-table :table-data="viewerShortcuts" />
    </div>
  </div>
</template>

<script>
import ShortcutsAndVoiceCommandsTable from '@/components/help/shortcutsAndVoiceCommands/ShortcutsAndVoiceCommandsTable'

export default {
    name: 'ViewerHelpTab',
    components: {
        ShortcutsAndVoiceCommandsTable
    },
    data() {
        return {
            viewerShortcuts: [
                {
                    tableTitle: this.$t('component.shortcutsModal.labels.title.viewerTitle'),
                    tableElements: [
                        {
                            action: this.$t('component.shortcutsModal.labels.action.toggleViewerTools'),
                            shortcuts: [
                                { key: 'F1' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.toggleViewerTools')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.toggleViewerCaseElements'),
                            shortcuts: [
                                { key: 'F2' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.toggleViewerCaseElements')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.togglePictureMap'),
                            shortcuts: [
                                { key: 'Alt' },
                                { key: 'M' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.togglePictureMap')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.viewPictureInformation'),
                            shortcuts: [
                                { key: 'Alt' },
                                { key: 'I' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.viewPictureInformation')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.movePictureRight'),
                            shortcuts: [
                                { key: 'Alt' },
                                { key: 'far fa-arrow-right', icon: true }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.movePictureRight')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.movePictureLeft'),
                            shortcuts: [
                                { key: 'Alt' },
                                { key: 'far fa-arrow-left', icon: true }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.movePictureLeft')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.movePictureDown'),
                            shortcuts: [
                                { key: 'Alt' },
                                { key: 'far fa-arrow-down', icon: true }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.movePictureDown')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.movePictureUp'),
                            shortcuts: [
                                { key: 'Alt' },
                                { key: 'far fa-arrow-up', icon: true }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.movePictureUp')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.zoomInPicture'),
                            shortcuts: [
                                { key: 'Alt' },
                                { key: '+' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.zoomInPicture')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.zoomOutPicture'),
                            shortcuts: [
                                { key: 'Alt' },
                                { key: '-' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.zoomOutPicture')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.savePicture'),
                            shortcuts: [
                                { key: 'Alt' },
                                { key: 'S' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.savePicture')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.zoomSelection'),
                            shortcuts: [
                                { key: 'Shift' },
                                { key: 'far fa-mouse-pointer', icon: true }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.zoomSelection')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.rotate'),
                            shortcuts: [
                                { key: 'Shift' },
                                { key: 'Alt' },
                                { key: 'far fa-mouse-pointer', icon: true }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.rotate')
                        }
                    ]
                }
            ]
        }
    }
}
</script>
